module.exports = __webpack_public_path__ + "img/section3_m.baaf4c08.jpg";